import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Footer() {
  const [tooltip, setTooltip] = useState(false);
  const whatsappNumber = '905400015806';
  const whatsappMessage = encodeURIComponent('Merhaba! Turlarınız hakkında bilgi almak istiyorum.');

  return (
    <>
      {/* Floating WhatsApp Button */}
      <a
        href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 left-6 z-50 group flex items-center gap-3 cursor-pointer"
        onMouseEnter={() => setTooltip(true)}
        onMouseLeave={() => setTooltip(false)}
      >
        {/* Tooltip */}
        <div
          className={`bg-white dark:bg-stone-800 text-stone-800 dark:text-white text-sm font-medium px-4 py-2 rounded-xl shadow-lg whitespace-nowrap transition-all duration-300 ${
            tooltip ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-2 pointer-events-none'
          }`}
        >
          <span className="block text-xs text-stone-500 dark:text-stone-400 mb-0.5">Hızlı İletişim</span>
          WhatsApp&apos;tan Yaz
        </div>

        {/* Button */}
        <div className="relative w-14 h-14 flex items-center justify-center rounded-full bg-[#25D366] shadow-lg hover:scale-110 transition-transform duration-300">
          {/* Pulse ring */}
          <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" />
          <div className="w-14 h-14 flex items-center justify-center">
            <i className="ri-whatsapp-line text-white text-2xl" />
          </div>
        </div>
      </a>

      <footer className="bg-stone-800 text-white pt-16 pb-8">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10 pb-12 border-b border-stone-700">
            {/* Brand */}
            <div className="md:col-span-1">
              <img
                src="https://storage.readdy-site.link/project_files/904466f0-2c05-4555-9f8d-869e0816a927/e2d94e9e-889c-4573-8429-0052ad575f89_Adsz-tasarm-3.png?v=589ebfa6144df8359c3a9f9f79357ea7"
                alt="Ankara Travelers"
                className="h-14 w-auto object-contain mb-4"
              />
              <p className="text-stone-400 text-sm leading-relaxed mb-6">
                Ankara&apos;dan dünyaya açılan kapınız. Günübirlik gezilerden yurt dışı turlarına kadar hayalinizdeki tatili gerçeğe dönüştürüyoruz.
              </p>
              <div className="flex items-center gap-3">
                {[
                  { icon: 'ri-facebook-fill', href: '#' },
                  { icon: 'ri-instagram-line', href: '#' },
                  { icon: 'ri-twitter-x-line', href: '#' },
                  { icon: 'ri-youtube-line', href: '#' },
                  { icon: 'ri-whatsapp-line', href: `https://wa.me/${whatsappNumber}?text=${whatsappMessage}` },
                ].map(item => (
                  <a
                    key={item.icon}
                    href={item.href}
                    target={item.href !== '#' ? '_blank' : undefined}
                    rel="noopener noreferrer"
                    className="w-9 h-9 flex items-center justify-center rounded-full border border-stone-600 text-stone-400 hover:text-orange-400 hover:border-orange-400 transition-colors cursor-pointer"
                  >
                    <i className={`${item.icon} text-sm`} />
                  </a>
                ))}
              </div>
            </div>

            {/* Turlar */}
            <div>
              <h4 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">Turlar</h4>
              <ul className="space-y-3">
                {[
                  { label: 'Günübirlik Turlar', path: '/gunubirlik-turlar' },
                  { label: 'Konaklamalı Turlar', path: '/konaklamali-turlar' },
                  { label: 'Ulaşımlı Tatil Paketleri', path: '/ulasimli-tatil' },
                  { label: 'Yurt Dışı Turlar', path: '/yurtdisi-turlar' },
                ].map(link => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-stone-400 hover:text-orange-400 text-sm transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Kurumsal */}
            <div>
              <h4 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">Kurumsal</h4>
              <ul className="space-y-3">
                {[
                  { label: 'Hakkımızda', path: '/hakkimizda' },
                  { label: 'Sıkça Sorulan Sorular', path: '/sikca-sorulan-sorular' },
                  { label: 'Gizlilik Politikası', path: '/gizlilik-politikasi' },
                  { label: 'Kullanım Koşulları', path: '/kullanim-kosullari' },
                ].map(item => (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      className="text-stone-400 hover:text-orange-400 text-sm transition-colors cursor-pointer"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* İletişim */}
            <div>
              <h4 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">Bize Ulaşın</h4>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-phone-line text-orange-400 text-sm" />
                  </div>
                  <span className="text-stone-400 text-sm">+90 540 001 5806</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-whatsapp-line text-orange-400 text-sm" />
                  </div>
                  <a
                    href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-stone-400 hover:text-orange-400 text-sm transition-colors cursor-pointer"
                  >
                    WhatsApp ile Yaz
                  </a>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-mail-line text-orange-400 text-sm" />
                  </div>
                  <span className="text-stone-400 text-sm">info@ankaratravelers.com</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-map-pin-line text-orange-400 text-sm" />
                  </div>
                  <span className="text-stone-400 text-sm">Kızılay, Ankara, Türkiye</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Copyright */}
          <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-stone-500 text-sm">
              © 2025 Ankara Travelers. Tüm hakları saklıdır.
            </p>
            <div className="flex items-center gap-4">
              <p className="text-stone-600 text-xs">
                Türkiye Seyahat Acentaları Birliği Üyesi
              </p>
              <Link
                to="/admin"
                className="flex items-center gap-1.5 text-stone-400 hover:text-orange-400 text-xs transition-colors cursor-pointer border border-stone-600 hover:border-orange-400 px-3 py-1.5 rounded-lg"
              >
                <i className="ri-settings-3-line text-sm" />
                <span>Admin</span>
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
